/**
 * Small shared banners for the wizard invalidation UX (spec P2 §4):
 * - ReadOnlyStepBanner: shown atop a completed step's read-only content,
 *   with the explicit "Edit this step" intent gate.
 * - RegeneratedNotice: one-line "Regenerated because {step} changed" shown
 *   on a step that was just freshly regenerated due to an upstream edit.
 */
import { Pencil, RefreshCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ReadOnlyStepBanner = ({ stepId, onEdit }) => (
  <div className="mb-6 flex items-center justify-between gap-3 rounded-sm border border-zinc-200 bg-zinc-50 px-4 py-3">
    <p className="text-sm text-zinc-600">
      This step is complete. Review the details below, or edit them if anything needs to change.
    </p>
    <Button
      variant="outline"
      size="sm"
      onClick={onEdit}
      className="border-zinc-300 shrink-0"
      data-testid={`edit-step-${stepId}-btn`}
    >
      <Pencil className="w-3.5 h-3.5 mr-1.5" /> Edit this step
    </Button>
  </div>
);

// Pass `message` for a full custom line (e.g. "Questions regenerated
// because Uploads changed — review any customizations."), or `causeLabel`
// for the generic "Regenerated because {causeLabel} changed." template.
export const RegeneratedNotice = ({ causeLabel, message }) => (
  <div
    className="mb-6 flex items-center gap-2 rounded-sm border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800"
    data-testid="regenerated-notice"
  >
    <RefreshCcw className="w-4 h-4 shrink-0" />
    {message || `Regenerated because ${causeLabel} changed.`}
  </div>
);

export default ReadOnlyStepBanner;
